/**
 * Downscale a File (image) client-side to keep upload payloads small.
 * Returns a JPEG data URL under ~200 KB.
 */
export async function fileToDownscaledBase64(file, maxWidth = 1000, quality = 0.85) {
  if (!file) throw new Error("no file");
  if (!file.type?.startsWith("image/")) {
    // Non-image (e.g. PDF) — return raw base64
    return await fileToRawBase64(file);
  }
  const dataUrl = await fileToRawBase64(file);
  const img = await loadImage(dataUrl);
  const ratio = Math.min(1, maxWidth / img.width);
  const w = Math.round(img.width * ratio);
  const h = Math.round(img.height * ratio);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", quality);
}

/**
 * Downscale an image File and return a JPEG Blob, ready for multipart upload.
 */
export async function downscaleToBlob(file, maxWidth = 1400, quality = 0.85) {
  const dataUrl = await fileToRawBase64(file);
  const img = await loadImage(dataUrl);
  const ratio = Math.min(1, maxWidth / img.width);
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.width * ratio);
  canvas.height = Math.round(img.height * ratio);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  return await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
}

export function fileToRawBase64(file) {  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
